// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
  * EventSchema - Implements schema.org Event
  *
  * Describes a webpage
  *
  * @example
    <EventSchema data={data}>
  *
  * @param {string} data.name - Name of the event
  * @param {string} data.url - URL for the event
  * @param {array} data.description - A short summary of the event
  * @param {array} data.startDate - Date and time the event starts
  * @param {array} data.endDate - Date and time the event ends
  * @param {array} data.locationName - Where does this event happen?
  * @param {array} data.locationUrl - Website for the event
  * @param {string} data.streetAddress - Street address of the event
  * @param {string} data.addressLocality - Locality of the event
  * @param {string} data.addressRegion - Region of the event
  * @param {string} data.postalCode - Postal code of event
  * @param {string} data.addressCountry - Country of the event
  * @param {string} data.image - Required. A unique banner image.
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://schema.org/WebSite|Schema.org Webpage Docs}
  */
var EventSchema = function EventSchema(props) {
  var data = props.data;


  var sanitized = data.url;
  if (sanitized.endsWith('/')) {
    sanitized = sanitized.substring(0, sanitized.length - 1);
  }

  var schemaOrgJSONLD = {
    '@context': 'http://schema.org',
    '@type': 'Event',
    name: data.name,
    url: sanitized,
    description: data.description,
    startDate: data.startDate,
    endDate: data.endDate,
    image: data.image,
    location: {
      '@type': 'Place',
      name: data.locationName,
      sameAs: data.locationUrl,
      address: {
        '@type': 'PostalAddress',
        streetAddress: data.streetAddress,
        addressLocality: data.addressLocality,
        addressRegion: data.addressRegion,
        postalCode: data.postalCode,
        addressCountry: data.addressCountry
      }
    },
    performer: {
      '@type': 'Person',
      name: data.performer.name,
      image: data.performer.image,
      sameAs: data.performer.sameAs
    },
    offers: {
      '@type': 'Offer',
      availability: 'http://schema.org/LimitedAvailability',
      price: data.offers.price,
      priceCurrency: data.offers.priceCurrency,
      url: sanitized
    }
  };

  return React.createElement(
    Helmet,
    null,
    React.createElement(
      'script',
      { type: 'application/ld+json' },
      JSON.stringify(schemaOrgJSONLD)
    )
  );
};

EventSchema.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object // eslint-disable-line react/forbid-prop-types
} : {};

EventSchema.defaultProps = {
  data: {}

  // ----------------------------------------------------------------------------
  // --------------------------------------------------------------------- Export
  // ----------------------------------------------------------------------------
};export default EventSchema;